import type {DiscoveryEventKey} from "@/app/actions/trackDiscoveryEventUtils";

/**
 * Fires a Discovery funnel event via `navigator.sendBeacon` instead of the
 * `trackDiscoveryEvent` Server Action. `sendBeacon` is guaranteed best-effort
 * delivered even through page unload, so use this (not the Server Action)
 * for click handlers on plain `<a href>` navigations — a full-page nav
 * aborts a fire-and-forget Server Action fetch before it can complete.
 */
export function sendDiscoveryEventBeacon(
	event: DiscoveryEventKey,
	properties?: Record<string, unknown>,
	options?: {referrer?: string | null}
): void {
	if (typeof navigator === "undefined" || !navigator.sendBeacon) {
		return;
	}

	const basePath = process.env.NEXT_PUBLIC_DISCOVERY_BASE_PATH ?? "";
	const payload = new Blob(
		[JSON.stringify({event, properties, referrer: options?.referrer})],
		{type: "application/json"}
	);
	navigator.sendBeacon(`${basePath}/api/track-discovery-event`, payload);
}
